<div class="w-full flex flex-col flex-1 min-h-0">
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 bg-white rounded-xl border border-slate-200 p-6">
      <p-skeleton width="12rem" height="1.5rem" class="mb-4" />
      @for (row of skeletonRows; track row) {
        <p-skeleton height="2.5rem" styleClass="mb-2" />
      }
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <p class="text-red-800">{{ error() }}</p>
      <button type="button" (click)="load()" class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg">Reintentar</button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-100 text-emerald-700">
                <i class="pi pi-building-columns"></i>
              </span>
              Cuentas bancarias
            </h2>
            <p class="text-sm text-slate-500 mt-1">CLABEs de la empresa para conciliar estados de cuenta.</p>
          </div>
          <a routerLink="/bank-accounts/nuevo" appDisableUnless="BANK_ACCOUNT_WRITE">
            <p-button label="Nueva cuenta" icon="pi pi-plus" size="small" appDisableUnless="BANK_ACCOUNT_WRITE" />
          </a>
        </div>
      </div>

      <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
        <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
          <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
            <p-floatlabel class="w-full" variant="on">
              <p-iconfield class="w-full">
                <p-inputicon class="pi pi-search text-sm" />
                <input pInputText id="filterBankQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
              </p-iconfield>
              <label for="filterBankQ">Alias, banco o CLABE</label>
            </p-floatlabel>
          </div>
          <p-floatlabel class="w-full min-w-0 sm:w-36" variant="on">
            <p-select formControlName="state" inputId="filterBankState" [options]="stateOptions" optionLabel="label" optionValue="value" size="small" class="w-full" />
            <label for="filterBankState">Estado</label>
          </p-floatlabel>
          @if (hasActiveFilters()) {
            <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" severity="secondary" type="button" (onClick)="clearFilters()" />
          }
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-hidden">
        <p-table
          [value]="items()"
          dataKey="id"
          [lazy]="true"
          [scrollable]="true"
          scrollHeight="flex"
          [totalRecords]="totalItems()"
          [first]="currentPage() * pageSize()"
          [rows]="pageSize()"
          [rowsPerPageOptions]="pageSizeOptions"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          [loading]="loading()"
          [paginator]="true"
          (onLazyLoad)="onLazyLoad($event)"
          styleClass="bank-accounts-table p-datatable-striped p-datatable-sm"
          [rowHover]="true">
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>Alias</th>
              <th class="hidden sm:table-cell">Banco</th>
              <th>CLABE</th>
              <th class="hidden sm:table-cell">Moneda</th>
              <th class="text-center">Liquidación</th>
              <th class="!text-right">Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr class="cursor-pointer" (click)="goTo(row)">
              <td>
                <span class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-600">
                  <i class="pi pi-building-columns"></i>
                </span>
              </td>
              <td class="font-medium text-slate-900">{{ row.alias }}</td>
              <td class="hidden sm:table-cell text-slate-700">{{ row.bankName }}</td>
              <td class="font-mono text-sm">{{ row.clabe }}</td>
              <td class="hidden sm:table-cell">{{ row.currency?.code || '—' }}</td>
              <td class="text-center">
                <p-tag [value]="row.settlementAccount ? 'Sí' : 'No'" [severity]="row.settlementAccount ? 'success' : 'secondary'" />
              </td>
              <td class="!text-right" (click)="$event.stopPropagation()">
                <p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" severity="secondary" (onClick)="openRowMenu($event, row)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="!text-center !py-10 text-slate-500">No hay cuentas bancarias.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>
<p-menu #rowMenu [popup]="true" [model]="rowMenuItems" appendTo="body" />
